<template>
  <div>
    <fieldset
      :ref="generateSafeId(fieldQuestionId, 'wrapper')"
      class="RMPE-DynamicField"
      :class="{ 'RMPE-HasError': fieldHasError }"
    >
      <legend
        class="label"
      >
        <span
          :class="{'RMPE-Required': question.required}"
          v-html="question.label"
        />
      </legend>
      <ul class="control">
        <li
          v-for="(option, index) in options"
          :key="option.id"
        >
          <label
            :ref="index === 0 ? 'auto-focus-target' : null"
            :for="generateSafeId(fieldQuestionId, option.id)"
            class="checkbox RMPE-CheckRadio"
            tabindex="0"
            @keydown.space.prevent="fakeClickOnInput(option.id)"
            @blur="isBlurred = true"
          >
            <font-awesome
              :icon="getIcon(option.id)"
              class="RMPE-CheckRadio-Icon"
            />
            <input
              :id="generateSafeId(fieldQuestionId, option.id)"
              :ref="generateSafeId(fieldQuestionId, option.id, 'ref')"
              v-model="interfaceValue"
              :checked="fieldValue === option.id"
              :value="option.id"
              type="checkbox"
            >
            <span class="RMPE-CheckRadio-Label">{{ option.label }}</span>
          </label>
        </li>
      </ul>
    </fieldset>
    <ErrorMessage
      v-if="fieldHasError"
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <HintMessage
      v-else
      :hint="question.warningMessage"
    />
  </div>
</template>

<script>
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';
import StaticFieldMixin from '../../mixins/static-field-mixin';
import CheckboxGroupFieldMixin from '../common/checkbox-group-field';

export default {
  mixins: [StaticFieldMixin, CheckboxGroupFieldMixin],

  methods: {
    getIcon(id) {
      if (!Array.isArray(this.fieldValue)) return faSquare;

      return this.fieldValue.includes(id) ? faCheckSquare : faSquare;
    },
  },
};
</script>

<style scoped lang="scss">

.RMPE-DynamicField{
  margin-bottom:5px;
}

.RMPE-CheckRadio{
  .RMPE-CheckRadio-Label{
    margin-bottom: 10px;
  }
}

.RMPE-MessageError{
  margin-bottom: 25px;
}

.RMPE-CheckRadio-Icon{
  margin-top: 3px;
}
</style>
